import { Sparkles } from 'lucide-react'
import { Avatar } from 'src/shared/components/ui/avatar'
import { cn } from 'src/shared/components/ui/utils'

export const SaraAvatar = ({ className }: { className?: string }) => (
  <Avatar
    size="sm"
    className={cn('mt-0.5 h-8 w-8 shrink-0 rounded-full border-0', className)}
  >
    <div className="relative flex h-full w-full items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-violet-500 via-purple-600 to-indigo-700">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,255,255,0.35),transparent_55%)]" />
      <Sparkles
        className="relative h-4 w-4 text-white drop-shadow-sm"
        aria-hidden
      />
    </div>
  </Avatar>
)
